import {UserDto} from './dto';

export interface TreeViewNode {
    value: string,
    label: string,
    children?: TreeViewNode[]
}

export interface Image {
    id: string,
    originalUrl: string,
    reviewStatus: ImageReviewStatusEnum,
    processingStatus: ImageProcStatusEnum,
    reviewCompletion: ImageReviewCompletionEnum,
    focalPointX: number,
    focalPointY: number,
    focalPointZ: number,
    fileName: string
}

export interface HwImage extends Image {
    activities: ImageActivity[]
}

export interface ImageActivity {
    activityId: string,
    activityName: string,
    referenceKey: string,
    imageType: ImageTypeEnum,
    activityHyperwaveUrl: string,
    activityCdnUrl: string
}

export interface SaveImage {
    imageId: string,
    focalPointX: number,
    focalPointY: number,
    focalPointZ: number
}

export interface SaveImageActivity {
    activityId: string,
    referenceKey: string,
    imageType: ImageTypeEnum
}

export interface UploadedFile {
    id: number,
    fileName: string,
    cdnUrl: string,
    uploadDate: string,
    fileType: UploadedFileTypeEnum,
    fileStatus: FileStatusEnum,
    imageData?: Image,
    largeImageUrl?: string,
    thumbnailImageUrl?: string
}

export class User implements UserDto {
    constructor() {
        this.email = '';
        this.password = '';
        this.isAdmin = false;
        this.isEnabled = true;
    }
    email: string;
    isAdmin: boolean;
    isEnabled: boolean;
    password: string;
}

export enum ImageReviewStatusEnum {
    NotReviewed = 'NotReviewed',
    ReviewedAuto = 'ReviewedAuto',
    ReviewedManual = 'ReviewedManual'
}

export enum ImageProcStatusEnum {
    NotProcessed = 'NotProcessed',
    Processing = 'Processing',
    Processed = 'Processed',
    Error = 'Error'
}

export enum ImageTypeEnum {
    NotSet = 'NotSet',
    Critical = 'Critical',
    Supportive = 'Supportive'
}

export enum ImageReviewCompletionEnum
{
    NotReviewed = 'NotReviewed',
    ReviewedPartial = 'ReviewedPartial',
    Reviewed = 'Reviewed'
}

export enum UploadedFileTypeEnum {
    Unknown = 'Unknown',
    Audio = 'Audio',
    Image = 'Image'
}

export enum FileStatusEnum {
    Processed = 'Processed',
    Processing = 'Processing',
    Error = 'Error'
}
    
